import { switchMap } from 'rxjs/operators'
import { useObservable } from '@cicero/ui'
import { useModel } from './useModel'
import { AttributeDoc, AttributeSchema } from '../AttributeSchema'
import { PageDoc } from '../PageSchema'
import { PageTemplateDoc, PageTemplateSchema } from '../PageTemplateSchema'

/**
 * Loads the relevant attributes for a given page
 * @param page 
 */
export const usePageAttributes = (page: PageDoc): AttributeDoc[] => {
  const Attributes = useModel(AttributeSchema)
  const PageTemplates = useModel(PageTemplateSchema)
  const attributes = useObservable(() => {
    if (!page?.template_id) { return Attributes.QUERY$() }

    return PageTemplates.GET$(page.template_id)
      .pipe(switchMap((template: PageTemplateDoc) => {
        const attribute_ids = template?.template_attributes.map(ta => ta.attribute_id)
        if (attribute_ids.length) {
          return Attributes.QUERY$(AttributeSchema.QUERIES.queryIds(attribute_ids))
        } else {
          return Attributes.QUERY$()
        }
      }))
  }, [], [page?.template_id])

  return attributes
}
